function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "page-multiple",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11608",
  "data-name": "Path 11608",
  d: "M12.06,34.805h1.251V10.718a.545.545,0,0,1,.545-.545H31.667V8.922a.545.545,0,0,0-.545-.545H12.06a.545.545,0,0,0-.545.545V34.26a.545.545,0,0,0,.545.544Z",
  transform: "translate(-11.515 -8.377)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11609",
  "data-name": "Path 11609",
  d: "M7.924,5.332V30.67a.545.545,0,0,0,.545.545H9.72V7.127a.545.545,0,0,1,.545-.545H28.076V5.331a.545.545,0,0,0-.545-.545H8.469a.545.545,0,0,0-.545.545Z",
  transform: "translate(-4.333 -1.195)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11610",
  "data-name": "Path 11610",
  d: "M4.333,1.741V27.079a.545.545,0,0,0,.545.545H23.94a.545.545,0,0,0,.545-.545V1.74a.545.545,0,0,0-.545-.545H4.878a.545.545,0,0,0-.545.545Z",
  transform: "translate(2.849 5.987)",
  fill: "#fff"
}));

var SvgPageMultiple = function SvgPageMultiple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.334,
    height: 33.61,
    viewBox: "0 0 27.334 33.61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPageMultiple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/page-multiple.470b144b.svg";
export { ForwardRef as ReactComponent };